// Business plan: $10/month covers the owner + 1 teammate, $5 per extra teammate.
export const SEAT_PRICE = 5;
export const BASE_PRICE = 10;

export const billableSeats = (seats) => Math.max(2, Number(seats) || 1);
export const monthlyCost = (seats) => billableSeats(seats) * SEAT_PRICE;
export const extraTeammates = (seats) => Math.max(0, (Number(seats) || 1) - 2);
